export const WHATSAPP_URL =
  "https://wa.me/628118460360?text=Halo%20PT%20Darma%20Daya%20Guna%2C%20saya%20ingin%20berkonsultasi%20mengenai%20layanan%20Anda.";
export const EMAIL = "darmadayaguna@gmail.com";
export const PHONE_DISPLAY = "0811 8460 360";
export const PDF_URL = "/assets/company-profile-ddg.pdf";
export const ADDRESS =
  "Komplek Permata Pamulang, Jl. Permata Permai Raya I Blok I8 No. 8, RT. 004/RW. 005, Bakti Jaya, Setu, Kota Tangerang Selatan, Banten 15314";
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(ADDRESS);

export const BNSP_PROGRAMS = [
  {
    group: "Training of Trainer (TOT)",
    items: [
      {
        name: "Junior Trainer BNSP",
        level: "Level 3",
        units: [
          "Mengidentifikasi Standar Kompetensi dan Kualifikasi Kerja",
          "Merencanakan Penyajian Materi Pelatihan Kerja",
          "Melaksanakan Pelatihan Tatap Muka (Face to Face)",
          "Menerapkan K3 di Lembaga Pelatihan Kerja",
          "Melakukan Komunikasi di Tempat Kerja",
          "Mengelola Bahan Pelatihan Kerja",
          "Mengelola Peralatan Pelatihan Kerja",
          "Memelihara Fasilitas Pelatihan Kerja",
          "Menilai Kemajuan Kompetensi Peserta Pelatihan Secara Individu",
        ],
      },
      {
        name: "Trainer BNSP",
        level: "Level 4",
        units: [
          "Menyusun Program Pelatihan Kerja",
          "Merencanakan Penyajian Materi Pelatihan Kerja",
          "Merencanakan Evaluasi Hasil Pembelajaran",
          "Melaksanakan Pelatihan Tatap Muka (Face to Face)",
          "Menerapkan K3 di Lembaga Pelatihan Kerja",
          "Mengelola Pemenuhan Persyaratan Bahasa, Literasi, dan Berhitung dalam Proses Pembelajaran",
          "Menilai Kemajuan Kompetensi Peserta Pelatihan Secara Individu",
          "Menentukan Kebutuhan Pelatihan Individu",
          "Merancang Strategi Pembelajaran",
          "Mengelola Bahan Pelatihan Kerja",
          "Mengelola Peralatan Pelatihan Kerja",
          "Menyiapkan Pelaksanaan Pelatihan atau Asesmen Berbasis Kompetensi",
          "Melaksanakan Pelatihan Berbasis Kompetensi (PBK)",
          "Melakukan Asesmen Berbasis Kompetensi",
        ],
      },
      {
        name: "Master Trainer BNSP",
        level: "Level 6",
        units: [
          "Menentukan Kebutuhan Pelatihan Mikro",
          "Menyusun Rencana Bisnis",
          "Merencanakan Strategi Pemasaran Pelatihan Kerja",
          "Merancang Platform E-learning",
          "Mengembangkan Jejaring Kerjasama Kemitraan Antar Lembaga/Perusahaan",
          "Memfasilitasi E-learning",
          "Melakukan Negosiasi dengan Mitra Lembaga Pelatihan Kerja",
          "Memasarkan Program Pelatihan Kerja",
          "Membuat Peta Kompetensi",
          "Merumuskan Standar Kompetensi",
          "Menentukan Kebutuhan Pelatihan Makro",
          "Mengembangkan Program Pelatihan Kerja",
          "Mengevaluasi Pelaksanaan Program Pelatihan Kerja",
          "Mengevaluasi Biaya Suatu Program Pelatihan Kerja",
        ],
      },
    ],
  },
  {
    group: "Human Resource Management (HRM)",
    items: [
      {
        name: "Human Capital (HC) Officer BNSP",
        audience: [
          "HR/HC Staff di perusahaan",
          "Mahasiswa yang ingin berkarir sebagai HR/HC Staff",
          "Fresh graduate yang ingin berkarir sebagai HR Staff",
          "Karyawan/profesional di bidang HR/HC/SDM",
          "Siapapun yang ingin menjadi HR/HC Staff bersertifikat profesi BNSP",
        ],
        units: [
          "Menyusun Uraian Jabatan",
          "Melakukan Administrasi Jaminan Sosial",
          "Melakukan Administrasi Pengupahan",
          "Melakukan Administrasi Penerapan Kebijakan MSDM",
        ],
      },
      {
        name: "Human Capital (HC) Supervisor BNSP",
        audience: [
          "HR/HC Supervisor di perusahaan",
          "Karyawan berpengalaman di bidang HR/HC/SDM",
          "Profesional di bidang HR/HC/SDM",
          "Siapapun yang ingin menjadi HR/HC Supervisor bersertifikat profesi BNSP",
        ],
        units: [
          "Menyusun Uraian Jabatan",
          "Menyusun Standar Operasional Prosedur (SOP) MSDM",
          "Menyusun Sistem Remunerasi",
          "Menyusun Kebutuhan Pembelajaran dan Pengembangan",
          "Membuat Kesepakatan Kerja",
        ],
      },
      {
        name: "Learning & Development (L&D) Manager BNSP",
        units: [
          "Menyusun Uraian Jabatan",
          "Melaksanakan Analisis Beban Kerja",
          "Menyusun Standar Operasional Prosedur (SOP) MSDM",
          "Menyusun Grading Jabatan",
          "Mengelola Proses Perumusan Indikator Kinerja Individu",
          "Menindaklanjuti Hasil Penilaian Kinerja Individu",
          "Menyusun Kebutuhan Pembelajaran dan Pengembangan",
          "Merancang Program Pembelajaran dan Pengembangan",
          "Melaksanakan Kegiatan Pembelajaran dan Pengembangan",
          "Mengevaluasi Pelaksanaan Program Pembelajaran dan Pengembangan",
          "Merancang Model dan Kamus Kompetensi",
          "Menyusun Kelompok Pekerja Bertalenta (Talent Pool)",
          "Mengelola Program Pengembangan Kelompok Pekerja Bertalenta (Talent Pool)",
          "Merancang Jalur Karir Pekerja",
          "Mengelola Program Suksesi",
        ],
      },
    ],
  },
];

export const content = {
  id: {
    nav: {
      about: "Manifesto",
      services: "Layanan",
      contact: "Kontak",
      articles: "Artikel",
      cta: "Mulai Konsultasi",
    },
    hero: {
      eyebrow: "PT Darma Daya Guna — Training & Consultant · Est. 2024",
      lines: [
        { text: "Kepatuhan yang", tone: "ink" },
        { text: "membuka pasar.", tone: "green" },
        { text: "Pelatihan yang", tone: "ink" },
        { text: "menggerakkan tim.", tone: "red" },
      ],
      sub: "Kami mendampingi perusahaan tekstil, garmen, dan manufaktur memenuhi standar internasional — dari Social Compliance hingga sertifikasi Textile Exchange — sekaligus menumbuhkan kapabilitas tim Anda.",
      ctaPrimary: "Jadwalkan Konsultasi",
      ctaSecondary: "Unduh Company Profile",
      stats: [
        { value: "7", label: "Bidang Keahlian" },
        { value: "20+", label: "Standar Internasional" },
        { value: "2024", label: "Tahun Berdiri" },
        { value: "100%", label: "Pendampingan Penuh" },
      ],
      scroll: "Gulir ke bawah",
    },
    manifesto: {
      label: "Manifesto Kami",
      chapters: [
        {
          num: "01",
          title: "Siapa Kami",
          body: "Darma Daya Guna lahir pada 2024 dengan satu keyakinan: kepatuhan bukan beban, melainkan keunggulan kompetitif. Kami adalah tim praktisi yang berpikir ke depan, bergerak cepat, dan bekerja berdampingan dengan klien lintas industri untuk menciptakan pertumbuhan yang berdampak dan berkelanjutan.",
        },
        {
          num: "02",
          title: "Visi",
          body: "Memberdayakan bisnis dan komunitas melalui layanan yang terdepan, mendorong pertumbuhan berkelanjutan, dan menciptakan nilai jangka panjang bagi seluruh pemangku kepentingan.",
        },
        {
          num: "03",
          title: "Misi",
          body: "Diakui atas komitmen kami terhadap kualitas, inovasi, dan kepuasan pelanggan — di setiap audit, setiap pelatihan, dan setiap proyek yang kami kerjakan.",
        },
        {
          num: "04",
          title: "Mengapa DDG",
          body: "Pendekatan end-to-end: penilaian kesenjangan, perbaikan sistem, pelatihan tim, hingga pendampingan audit. Satu partner tepercaya untuk seluruh perjalanan kepatuhan dan pengembangan organisasi Anda.",
        },
      ],
    },
    services: {
      label: "Layanan & Keahlian",
      title: "Satu partner, tujuh bidang keahlian.",
      desc: "Dari ruang produksi hingga ruang rapat — kami menyiapkan perusahaan Anda memenuhi standar global dan membangun tim yang tangguh.",
      detailCta: "Diskusikan Kebutuhan Anda",
      close: "Tutup",
      pointsLabel: "Yang Anda Dapatkan",
      unitsLabel: "Unit Kompetensi",
      programsLabel: "Skema Sertifikasi",
      audienceLabel: "Untuk Siapa",
      standardsLabel: "Standar & Cakupan",
      items: [
        {
          id: "social-compliance",
          num: "01",
          title: "Social Compliance",
          tags: ["SLCP", "WRAP", "BSCI", "SMETA", "Better Work"],
          desc: "Pendampingan menyeluruh untuk memenuhi standar sosial dan ketenagakerjaan internasional — syarat utama membuka pasar ekspor global.",
          detail: "Kami memetakan kesenjangan praktik ketenagakerjaan Anda terhadap standar internasional, membangun sistem dan dokumentasi yang dibutuhkan, melatih tim internal, dan mendampingi hingga audit selesai.",
          points: [
            "Gap assessment terhadap standar pilihan Anda",
            "Penyusunan sistem, kebijakan & dokumentasi",
            "Pelatihan tim internal & manajemen",
            "Pendampingan penuh saat audit berlangsung",
          ],
          image:
            "https://images.unsplash.com/photo-1741176505800-caaa3a52631a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxnYXJtZW50JTIwZmFjdG9yeSUyMHRleHRpbGUlMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc4NzkxNjYwOHww&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "textile-exchange",
          num: "02",
          title: "Textile Exchange",
          tags: ["GRS", "GOTS", "RCS", "OCS"],
          desc: "Sertifikasi rantai pasok material daur ulang dan organik — membuktikan klaim keberlanjutan produk tekstil Anda.",
          detail: "Kami membantu perusahaan Anda membangun rantai ketertelusuran (chain of custody) yang kredibel, dari pemasok hingga produk jadi, sesuai standar Textile Exchange.",
          points: [
            "Pemetaan rantai pasok & ketertelusuran material",
            "Penyiapan sistem pencatatan & verifikasi",
            "Pelatihan tim produksi dan dokumentasi",
            "Pendampingan sertifikasi GRS, GOTS, RCS, OCS",
          ],
          image: null,
        },
        {
          id: "chemical-management",
          num: "03",
          title: "Chemical Management",
          tags: ["ZDHC", "MRSL", "RSL"],
          desc: "Pengelolaan bahan kimia yang aman, patuh, dan transparan sesuai standar ZDHC untuk industri tekstil dan alas kaki.",
          detail: "Kami membangun sistem manajemen kimia yang melindungi pekerja, lingkungan, dan reputasi merek Anda — dari inventaris hingga pengujian limbah.",
          points: [
            "Inventaris & penilaian risiko bahan kimia",
            "Implementasi ZDHC MRSL & RSL",
            "SOP penyimpanan, penanganan & pembuangan",
            "Pelatihan penanggung jawab kimia",
          ],
          image:
            "https://images.unsplash.com/photo-1524292332709-b33366a7f165?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxnYXJtZW50JTIwZmFjdG9yeSUyMHRleHRpbGUlMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc4NzkxNjYwOHww&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "environmental",
          num: "04",
          title: "Environmental",
          tags: ["BEPI", "Worldly FEM", "ISO 14001"],
          desc: "Sistem manajemen lingkungan dan pengukuran kinerja fasilitas untuk operasional yang lebih hijau dan efisien.",
          detail: "Dari penilaian kinerja lingkungan fasilitas hingga sertifikasi ISO 14001, kami membantu Anda mengukur, mengelola, dan meningkatkan jejak lingkungan operasional.",
          points: [
            "Penilaian BEPI & Worldly (Higg) FEM",
            "Pembangunan sistem manajemen lingkungan ISO 14001",
            "Program efisiensi energi, air & limbah",
            "Pendampingan verifikasi pihak ketiga",
          ],
          image: null,
        },
        {
          id: "management-business",
          num: "05",
          title: "Management & Business",
          tags: ["Corporate Strategy", "System Management", "HR Management", "Leadership"],
          desc: "Penguatan strategi korporat, sistem manajemen, dan fungsi SDM agar organisasi tumbuh dengan struktur yang kokoh.",
          detail: "Kami bekerja bersama jajaran manajemen merancang strategi, merapikan sistem kerja, dan membangun fungsi SDM yang mendorong kinerja bisnis jangka panjang.",
          points: [
            "Penyusunan & penajaman strategi korporat",
            "Perancangan sistem manajemen perusahaan",
            "Pengembangan manajemen SDM",
            "Program kepemimpinan untuk manajer",
          ],
          image: null,
        },
        {
          id: "soft-skill",
          num: "06",
          title: "Soft Skill Training",
          tags: ["Communication", "Team Work", "Problem Solving", "Time Management", "Emotional Intelligence", "Adaptability", "Leadership", "Stress Management", "Critical Thinking", "Growth Mindset"],
          desc: "Pelatihan keterampilan interpersonal yang membangun budaya kerja produktif, adaptif, dan kolaboratif.",
          detail: "Program pelatihan interaktif yang dirancang sesuai konteks perusahaan Anda — dari komunikasi efektif hingga growth mindset — untuk tim di semua level.",
          points: [
            "Kurikulum disesuaikan kebutuhan perusahaan",
            "Format in-house training interaktif",
            "Modul praktis dengan studi kasus nyata",
            "Evaluasi & tindak lanjut pasca pelatihan",
          ],
          image:
            "https://images.unsplash.com/photo-1581091877018-dac6a371d50f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjB0cmFpbmluZyUyMHByZXNlbnRhdGlvbiUyMGJ1c2luZXNzJTIwY29uc3VsdGluZ3xlbnwwfHx8fDE3ODc5MTY2MDh8MA&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "sertifikasi-bnsp",
          num: "07",
          title: "Sertifikasi BNSP",
          tags: ["TOT", "HRM", "BNSP Level 3", "BNSP Level 4", "BNSP Level 6", "+3 Skema"],
          desc: "Sertifikasi profesi nasional dari Badan Nasional Sertifikasi Profesi (BNSP) untuk trainer dan praktisi SDM — jalur Training of Trainer (TOT) dan Human Resource Management (HRM).",
          detail: "DDG menyelenggarakan pelatihan dan sertifikasi kompetensi resmi BNSP melalui dua jalur: Training of Trainer (TOT) untuk calon trainer dari level junior hingga master, dan Human Resource Management (HRM) untuk praktisi SDM dari level officer hingga manager. Setiap skema dinilai berdasarkan unit kompetensi resmi BNSP.",
          points: [
            "Sertifikat kompetensi resmi dari BNSP",
            "Pelatihan berbasis unit kompetensi sesuai skema BNSP",
            "Asesmen oleh asesor kompetensi berlisensi",
            "6 skema: Junior Trainer, Trainer, Master Trainer, HC Officer, HC Supervisor, dan L&D Manager",
          ],
          image: null,
          programs: BNSP_PROGRAMS,
        },
      ],
    },
    contact: {
      label: "Hubungi Kami",
      title: "Mulai percakapan, kami yang bergerak.",
      desc: "Ceritakan kebutuhan perusahaan Anda — tim kami akan merespons dalam 1×24 jam kerja.",
      infoTitle: "Kontak Langsung",
      whatsappCta: "Chat via WhatsApp",
      emailLabel: "Email",
      phoneLabel: "Telepon / WhatsApp",
      addressLabel: "Alamat Kantor",
      mapsCta: "Lihat di Google Maps",
      responseNote: "Respons cepat pada jam kerja (Senin–Jumat, 09.00–17.00 WIB)",
      form: {
        name: "Nama Lengkap *",
        company: "Perusahaan",
        email: "Email *",
        phone: "No. WhatsApp",
        service: "Topik Layanan",
        servicePlaceholder: "Pilih layanan yang Anda minati",
        message: "Pesan Anda *",
        submit: "Kirim Pesan",
        sending: "Mengirim…",
      },
      toastSuccess: "Pesan terkirim! Tim DDG akan menghubungi Anda dalam 1×24 jam kerja.",
      toastError: "Gagal mengirim pesan. Silakan coba lagi atau hubungi kami via WhatsApp.",
    },
    footer: {
      tagline: "Training & Consultant untuk industri tekstil, garmen, dan manufaktur Indonesia.",
      navTitle: "Navigasi",
      servicesTitle: "Layanan",
      contactTitle: "Kontak",
      rights: "© 2026 PT Darma Daya Guna. Seluruh hak cipta dilindungi.",
      adminLink: "Admin",
    },
    insights: {
      label: "Wawasan & Artikel",
      title: "Catatan lapangan dari dunia compliance.",
      more: "Lihat Semua Artikel",
      readCta: "Baca Artikel",
      minRead: "menit baca",
    },
    blog: {
      back: "Semua Artikel",
      related: "Artikel Terkait",
      notFound: "Artikel tidak ditemukan.",
      title: "Wawasan & Artikel",
      desc: "Panduan praktis seputar social compliance, sertifikasi, dan pengembangan tim — ditulis dari pengalaman pendampingan langsung di lapangan.",
    },
    articles: [
      {
        slug: "apa-itu-social-compliance",
        category: "Compliance",
        date: "2026-08-10",
        readTime: 5,
        title: "Apa Itu Social Compliance dan Mengapa Penting bagi Industri Garmen?",
        excerpt: "SLCP, WRAP, BSCI, SMETA — standar-standar ini bukan sekadar formalitas, melainkan tiket masuk produk Indonesia ke pasar global.",
        blocks: [
          { p: "Bayangkan sebuah pabrik garmen yang produknya diekspor ke Eropa dan Amerika. Sebelum satu pun pesanan dikonfirmasi, buyer internasional hampir selalu mengajukan satu pertanyaan: apakah pabrik Anda lulus audit social compliance? Bagi banyak perusahaan, jawaban atas pertanyaan inilah yang menentukan apakah kontrak besar ditandatangani atau tidak." },
          { p: "Social compliance adalah kesesuaian praktik ketenagakerjaan dan sosial perusahaan terhadap standar internasional — mencakup upah, jam kerja, keselamatan kerja, larangan pekerja anak, hingga kebebasan berserikat. Standar yang umum digunakan buyer global antara lain SLCP, WRAP, BSCI, SMETA, dan Better Work." },
          { h: "Apa yang Dinilai Auditor?" },
          { p: "Audit social compliance menilai dokumentasi sekaligus praktik nyata di lapangan: catatan kehadiran dan lembur, slip gaji, kontrak kerja, kondisi fasilitas keselamatan, jalur evakuasi, hingga wawancara langsung dengan pekerja. Auditor mencari konsistensi antara dokumen dan kenyataan — dan di sinilah banyak perusahaan terjatuh." },
          { h: "Lebih dari Sekadar Sertifikat" },
          { p: "Perusahaan yang serius membangun social compliance merasakan manfaat jauh melampaui kelulusan audit: turnover pekerja menurun, produktivitas naik, dan kepercayaan buyer menguat. Kepatuhan berubah dari beban administrasi menjadi keunggulan kompetitif." },
          { h: "Mulai dari Mana?" },
          { p: "Langkah pertama adalah gap assessment — memetakan kondisi saat ini terhadap standar yang dituju. Dari sana, perusahaan membangun sistem, melatih tim, dan memperbaiki praktik sebelum audit sesungguhnya tiba. DDG mendampingi seluruh proses ini, dari penilaian awal hingga pendampingan saat audit berlangsung." },
        ],
      },
      {
        slug: "checklist-persiapan-audit-sosial",
        category: "Compliance",
        date: "2026-08-18",
        readTime: 6,
        title: "7 Langkah Persiapan Audit Sosial Sebelum Auditor Tiba",
        excerpt: "Kegagalan audit SLCP atau WRAP sering kali bukan karena pelanggaran besar, melainkan dokumentasi yang berantakan. Ini checklist yang kami gunakan bersama klien.",
        blocks: [
          { p: "Banyak perusahaan mempersiapkan audit sosial dengan panik dua minggu sebelum hari-H. Hasilnya bisa ditebak: temuan berulang dan skor yang mengecewakan. Persiapan yang baik dimulai jauh lebih awal — dan berikut tujuh langkah yang kami terapkan saat mendampingi klien." },
          { h: "1. Rapikan Dokumen Ketenagakerjaan" },
          { p: "Kontrak kerja, peraturan perusahaan, catatan kehadiran, dan slip gaji 12 bulan terakhir harus lengkap dan konsisten. Dokumen yang hilang atau tidak sinkron adalah sumber temuan paling umum." },
          { h: "2. Verifikasi Upah dan Lembur" },
          { p: "Pastikan upah memenuhi ketentuan minimum, lembur dihitung dan dibayar sesuai aturan, serta tidak melebihi batas jam. Lakukan rekonsiliasi antara catatan kehadiran dan pembayaran." },
          { h: "3. Cek Fasilitas Keselamatan" },
          { p: "APAR terisi dan tidak kedaluwarsa, jalur evakuasi bebas hambatan, pintu darurat tidak terkunci, mesin memiliki pelindung, dan APD tersedia serta benar-benar dipakai pekerja." },
          { h: "4. Siapkan Pekerja untuk Wawancara" },
          { p: "Wawancara pekerja bukan sesi menghafal jawaban. Pekerja perlu memahami haknya dan merasa aman menjawab jujur. Budaya terbuka justru memperkuat hasil audit." },
          { h: "5. Lakukan Internal Audit" },
          { p: "Simulasikan audit sesungguhnya beberapa minggu sebelumnya. Internal audit menemukan masalah saat masih ada waktu memperbaikinya — bukan saat auditor sudah duduk di ruang meeting." },
          { h: "6. Bentuk Tim Tanggap Audit" },
          { p: "Tunjuk penanggung jawab per area: HR, HSE, produksi, dan dokumentasi. Satu pintu koordinasi membuat audit berjalan lancar dan cepat." },
          { h: "7. Tutup Temuan Audit Sebelumnya" },
          { p: "Auditor selalu memeriksa status corrective action dari audit terdahulu. Temuan lama yang belum ditutup adalah tanda bahaya terbesar bagi buyer." },
          { p: "Ketujuh langkah ini terdengar sederhana, tetapi eksekusinya menuntut kedisiplinan sistem. DDG membantu perusahaan menyiapkannya secara terstruktur — dari gap assessment hingga pendampingan penuh saat hari audit tiba." },
        ],
      },
      {
        slug: "soft-skill-investasi-tersembunyi",
        category: "Training",
        date: "2026-08-24",
        readTime: 4,
        title: "Soft Skill: Investasi Tersembunyi di Balik Produktivitas Tim",
        excerpt: "Mesin boleh canggih dan SOP boleh rapi — tetapi komunikasi yang buruk bisa menggagalkan semuanya. Inilah mengapa pelatihan soft skill layak dianggarkan.",
        blocks: [
          { p: "Ketika perusahaan menghitung investasi, pelatihan teknis hampir selalu masuk anggaran — sementara pelatihan soft skill sering dianggap 'bonus jika ada sisa dana'. Padahal, sebagian besar masalah operasional sehari-hari justru berakar pada soft skill: instruksi yang tidak jelas, konflik antar-shift, atau supervisor yang kesulitan memberi umpan balik." },
          { h: "Biaya Tak Terlihat dari Soft Skill yang Lemah" },
          { p: "Kesalahan produksi karena miskomunikasi, tingginya turnover karena gaya kepemimpinan yang kasar, dan rapat yang berputar tanpa keputusan — semuanya adalah biaya nyata yang jarang tercatat di laporan keuangan. Riset konsisten menunjukkan tim dengan soft skill kuat lebih produktif, lebih adaptif, dan lebih loyal." },
          { h: "Lima Soft Skill Paling Berdampak di Lantai Produksi" },
          { p: "Dari pengalaman pendampingan kami, lima keterampilan paling terasa dampaknya: komunikasi yang jelas antar-lini, kerja sama tim lintas fungsi, problem solving yang terstruktur, manajemen waktu di tengah target produksi, dan kecerdasan emosional para supervisor — garda terdepan budaya kerja perusahaan." },
          { h: "Pelatihan yang Efektif Itu Kontekstual" },
          { p: "Pelatihan soft skill gagal ketika isinya generik. Program yang efektif menggunakan studi kasus nyata dari perusahaan itu sendiri, melibatkan praktik langsung, dan ditindaklanjuti dengan evaluasi. Itulah pendekatan yang kami bawa dalam setiap in-house training DDG." },
        ],
      },
    ],
    whatsapp: { label: "Chat WhatsApp" },
    servicePage: {
      back: "Kembali ke Beranda",
      cta: "Konsultasi Layanan Ini",
      openPage: "Lihat Halaman Layanan",
      related: "Layanan Lainnya",
      notFound: "Layanan tidak ditemukan.",
    },
  },

  en: {
    nav: {
      about: "Manifesto",
      services: "Services",
      contact: "Contact",
      articles: "Articles",
      cta: "Start a Consultation",
    },
    hero: {
      eyebrow: "PT Darma Daya Guna — Training & Consultant · Est. 2024",
      lines: [
        { text: "Compliance that", tone: "ink" },
        { text: "opens markets.", tone: "green" },
        { text: "Training that", tone: "ink" },
        { text: "moves teams.", tone: "red" },
      ],
      sub: "We guide textile, garment, and manufacturing companies toward international standards — from Social Compliance to Textile Exchange certifications — while building the capability of your people.",
      ctaPrimary: "Book a Consultation",
      ctaSecondary: "Download Company Profile",
      stats: [
        { value: "7", label: "Areas of Expertise" },
        { value: "20+", label: "International Standards" },
        { value: "2024", label: "Established" },
        { value: "100%", label: "End-to-End Support" },
      ],
      scroll: "Scroll down",
    },
    manifesto: {
      label: "Our Manifesto",
      chapters: [
        {
          num: "01",
          title: "Who We Are",
          body: "Darma Daya Guna was founded in 2024 on a single conviction: compliance is not a burden — it is a competitive advantage. We are a forward-thinking team of practitioners working side by side with clients across industries to create impactful, sustainable growth.",
        },
        {
          num: "02",
          title: "Vision",
          body: "To empower businesses and communities by offering cutting-edge services, fostering sustainable growth, and creating long-term value for all stakeholders.",
        },
        {
          num: "03",
          title: "Mission",
          body: "To be recognized for our commitment to quality, innovation, and customer satisfaction — in every audit, every training, and every project we deliver.",
        },
        {
          num: "04",
          title: "Why DDG",
          body: "An end-to-end approach: gap assessment, system improvement, team training, and on-site audit support. One trusted partner for your entire compliance and organizational development journey.",
        },
      ],
    },
    services: {
      label: "Services & Expertise",
      title: "One partner, seven areas of expertise.",
      desc: "From the production floor to the boardroom — we prepare your company to meet global standards and build resilient teams.",
      detailCta: "Discuss Your Needs",
      close: "Close",
      pointsLabel: "What You Get",
      unitsLabel: "Competency Units",
      programsLabel: "Certification Schemes",
      audienceLabel: "Who It's For",
      standardsLabel: "Standards & Scope",
      items: [
        {
          id: "social-compliance",
          num: "01",
          title: "Social Compliance",
          tags: ["SLCP", "WRAP", "BSCI", "SMETA", "Better Work"],
          desc: "End-to-end support to meet international social and labor standards — the key requirement to unlock global export markets.",
          detail: "We map your labor practices against international standards, build the required systems and documentation, train your internal team, and stand with you until the audit is complete.",
          points: [
            "Gap assessment against your chosen standard",
            "System, policy & documentation development",
            "Internal team & management training",
            "Full on-site audit accompaniment",
          ],
          image:
            "https://images.unsplash.com/photo-1741176505800-caaa3a52631a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxnYXJtZW50JTIwZmFjdG9yeSUyMHRleHRpbGUlMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc4NzkxNjYwOHww&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "textile-exchange",
          num: "02",
          title: "Textile Exchange",
          tags: ["GRS", "GOTS", "RCS", "OCS"],
          desc: "Supply-chain certification for recycled and organic materials — proving your textile sustainability claims.",
          detail: "We help your company build a credible chain of custody, from suppliers to finished products, in line with Textile Exchange standards.",
          points: [
            "Supply-chain mapping & material traceability",
            "Record-keeping & verification system setup",
            "Production and documentation team training",
            "GRS, GOTS, RCS, OCS certification support",
          ],
          image: null,
        },
        {
          id: "chemical-management",
          num: "03",
          title: "Chemical Management",
          tags: ["ZDHC", "MRSL", "RSL"],
          desc: "Safe, compliant, and transparent chemical management aligned with ZDHC standards for textile and footwear.",
          detail: "We build chemical management systems that protect your workers, the environment, and your brand reputation — from inventory to wastewater testing.",
          points: [
            "Chemical inventory & risk assessment",
            "ZDHC MRSL & RSL implementation",
            "Storage, handling & disposal SOPs",
            "Chemical officer training",
          ],
          image:
            "https://images.unsplash.com/photo-1524292332709-b33366a7f165?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxnYXJtZW50JTIwZmFjdG9yeSUyMHRleHRpbGUlMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc4NzkxNjYwOHww&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "environmental",
          num: "04",
          title: "Environmental",
          tags: ["BEPI", "Worldly FEM", "ISO 14001"],
          desc: "Environmental management systems and facility performance measurement for greener, more efficient operations.",
          detail: "From facility environmental performance assessments to ISO 14001 certification, we help you measure, manage, and improve your operational footprint.",
          points: [
            "BEPI & Worldly (Higg) FEM assessments",
            "ISO 14001 environmental management system",
            "Energy, water & waste efficiency programs",
            "Third-party verification support",
          ],
          image: null,
        },
        {
          id: "management-business",
          num: "05",
          title: "Management & Business",
          tags: ["Corporate Strategy", "System Management", "HR Management", "Leadership"],
          desc: "Strengthening corporate strategy, management systems, and HR functions so your organization grows on solid ground.",
          detail: "We work alongside your management team to design strategy, streamline operating systems, and build HR functions that drive long-term business performance.",
          points: [
            "Corporate strategy development & refinement",
            "Corporate management system design",
            "Human resource management development",
            "Leadership programs for managers",
          ],
          image: null,
        },
        {
          id: "soft-skill",
          num: "06",
          title: "Soft Skill Training",
          tags: ["Communication", "Team Work", "Problem Solving", "Time Management", "Emotional Intelligence", "Adaptability", "Leadership", "Stress Management", "Critical Thinking", "Growth Mindset"],
          desc: "Interpersonal skills training that builds a productive, adaptive, and collaborative work culture.",
          detail: "Interactive training programs tailored to your company context — from effective communication to growth mindset — for teams at every level.",
          points: [
            "Curriculum tailored to company needs",
            "Interactive in-house training format",
            "Practical modules with real case studies",
            "Post-training evaluation & follow-up",
          ],
          image:
            "https://images.unsplash.com/photo-1581091877018-dac6a371d50f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjB0cmFpbmluZyUyMHByZXNlbnRhdGlvbiUyMGJ1c2luZXNzJTIwY29uc3VsdGluZ3xlbnwwfHx8fDE3ODc5MTY2MDh8MA&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "sertifikasi-bnsp",
          num: "07",
          title: "BNSP Certification",
          tags: ["TOT", "HRM", "BNSP Level 3", "BNSP Level 4", "BNSP Level 6", "+3 Schemes"],
          desc: "National professional certification from Indonesia's National Professional Certification Board (BNSP) for trainers and HR practitioners — Training of Trainer (TOT) and Human Resource Management (HRM) tracks.",
          detail: "DDG delivers official BNSP competency training and certification through two tracks: Training of Trainer (TOT) for aspiring trainers from junior to master level, and Human Resource Management (HRM) for HR practitioners from officer to manager level. Every scheme is assessed against official BNSP competency units.",
          points: [
            "Official competency certificate from BNSP",
            "Training based on official BNSP competency units",
            "Assessment by licensed competency assessors",
            "6 schemes: Junior Trainer, Trainer, Master Trainer, HC Officer, HC Supervisor, and L&D Manager",
          ],
          image: null,
          programs: BNSP_PROGRAMS,
        },
      ],
    },
    contact: {
      label: "Get in Touch",
      title: "Start the conversation — we'll move.",
      desc: "Tell us about your company's needs — our team responds within one business day.",
      infoTitle: "Direct Contact",
      whatsappCta: "Chat via WhatsApp",
      emailLabel: "Email",
      phoneLabel: "Phone / WhatsApp",
      addressLabel: "Office Address",
      mapsCta: "View on Google Maps",
      responseNote: "Fast response during business hours (Mon–Fri, 09:00–17:00 WIB)",
      form: {
        name: "Full Name *",
        company: "Company",
        email: "Email *",
        phone: "WhatsApp Number",
        service: "Service Topic",
        servicePlaceholder: "Select the service you are interested in",
        message: "Your Message *",
        submit: "Send Message",
        sending: "Sending…",
      },
      toastSuccess: "Message sent! The DDG team will reach out within one business day.",
      toastError: "Failed to send. Please try again or reach us via WhatsApp.",
    },
    footer: {
      tagline: "Training & Consultant for Indonesia's textile, garment, and manufacturing industries.",
      navTitle: "Navigation",
      servicesTitle: "Services",
      contactTitle: "Contact",
      rights: "© 2026 PT Darma Daya Guna. All rights reserved.",
      adminLink: "Admin",
    },
    insights: {
      label: "Insights & Articles",
      title: "Field notes from the compliance world.",
      more: "View All Articles",
      readCta: "Read Article",
      minRead: "min read",
    },
    blog: {
      back: "All Articles",
      related: "Related Articles",
      notFound: "Article not found.",
      title: "Insights & Articles",
      desc: "Practical guides on social compliance, certification, and team development — written from hands-on field experience.",
    },
    articles: [
      {
        slug: "apa-itu-social-compliance",
        category: "Compliance",
        date: "2026-08-10",
        readTime: 5,
        title: "What Is Social Compliance and Why Does It Matter for the Garment Industry?",
        excerpt: "SLCP, WRAP, BSCI, SMETA — these standards are not mere formalities; they are your ticket into the global market.",
        blocks: [
          { p: "Picture a garment factory exporting to Europe and America. Before a single order is confirmed, international buyers almost always ask one question: has your factory passed a social compliance audit? For many companies, the answer determines whether a major contract gets signed or not." },
          { p: "Social compliance is the alignment of a company's labor and social practices with international standards — covering wages, working hours, occupational safety, the prohibition of child labor, and freedom of association. The standards most used by global buyers include SLCP, WRAP, BSCI, SMETA, and Better Work." },
          { h: "What Do Auditors Assess?" },
          { p: "A social compliance audit examines both documentation and real practice on the floor: attendance and overtime records, pay slips, employment contracts, safety facilities, evacuation routes, and direct worker interviews. Auditors look for consistency between paper and reality — and this is where many companies stumble." },
          { h: "More Than a Certificate" },
          { p: "Companies that take social compliance seriously feel benefits far beyond passing an audit: lower worker turnover, higher productivity, and stronger buyer trust. Compliance shifts from an administrative burden to a competitive advantage." },
          { h: "Where to Start?" },
          { p: "The first step is a gap assessment — mapping your current condition against the target standard. From there, the company builds systems, trains its team, and fixes practices before the real audit arrives. DDG accompanies this entire process, from initial assessment to on-site audit support." },
        ],
      },
      {
        slug: "checklist-persiapan-audit-sosial",
        category: "Compliance",
        date: "2026-08-18",
        readTime: 6,
        title: "7 Steps to Prepare for a Social Audit Before the Auditor Arrives",
        excerpt: "Failed SLCP or WRAP audits are rarely about major violations — they are about messy documentation. This is the checklist we use with our clients.",
        blocks: [
          { p: "Many companies prepare for a social audit in a panic two weeks before the day. The outcome is predictable: repeated findings and disappointing scores. Good preparation starts much earlier — and here are the seven steps we apply when accompanying clients." },
          { h: "1. Tidy Up Employment Documents" },
          { p: "Employment contracts, company regulations, attendance records, and the last 12 months of pay slips must be complete and consistent. Missing or mismatched documents are the most common source of findings." },
          { h: "2. Verify Wages and Overtime" },
          { p: "Ensure wages meet minimum requirements, overtime is calculated and paid correctly, and hour limits are respected. Reconcile attendance records against payments." },
          { h: "3. Check Safety Facilities" },
          { p: "Fire extinguishers charged and unexpired, evacuation routes clear, emergency exits unlocked, machine guards in place, and PPE available and actually worn by workers." },
          { h: "4. Prepare Workers for Interviews" },
          { p: "Worker interviews are not about memorizing answers. Workers need to understand their rights and feel safe answering honestly. An open culture actually strengthens your audit result." },
          { h: "5. Run an Internal Audit" },
          { p: "Simulate the real audit a few weeks ahead. An internal audit finds problems while there is still time to fix them — not when the auditor is already sitting in your meeting room." },
          { h: "6. Build an Audit Response Team" },
          { p: "Assign an owner for each area: HR, HSE, production, and documentation. A single coordination point keeps the audit running smoothly and quickly." },
          { h: "7. Close Previous Audit Findings" },
          { p: "Auditors always check the status of corrective actions from earlier audits. Old findings left open are the biggest red flag for buyers." },
          { p: "These seven steps sound simple, but executing them demands system discipline. DDG helps companies prepare in a structured way — from gap assessment to full support on audit day." },
        ],
      },
      {
        slug: "soft-skill-investasi-tersembunyi",
        category: "Training",
        date: "2026-08-24",
        readTime: 4,
        title: "Soft Skills: The Hidden Investment Behind Team Productivity",
        excerpt: "Machines can be sophisticated and SOPs can be tidy — but poor communication can undo it all. Here is why soft-skill training deserves a budget line.",
        blocks: [
          { p: "When companies count their investments, technical training almost always makes the budget — while soft-skill training is treated as a bonus if funds remain. Yet most day-to-day operational problems are rooted in soft skills: unclear instructions, cross-shift conflicts, or supervisors who struggle to give feedback." },
          { h: "The Invisible Cost of Weak Soft Skills" },
          { p: "Production errors from miscommunication, high turnover from harsh leadership styles, and meetings that circle without decisions — all are real costs that rarely appear in financial reports. Research consistently shows teams with strong soft skills are more productive, more adaptive, and more loyal." },
          { h: "Five Soft Skills with the Biggest Impact on the Production Floor" },
          { p: "From our accompanying experience, five skills make the most visible difference: clear communication across lines, cross-functional teamwork, structured problem solving, time management amid production targets, and the emotional intelligence of supervisors — the front line of company culture." },
          { h: "Effective Training Is Contextual" },
          { p: "Soft-skill training fails when its content is generic. Effective programs use real case studies from the company itself, involve hands-on practice, and are followed up with evaluation. That is the approach we bring to every DDG in-house training." },
        ],
      },
    ],
    whatsapp: { label: "WhatsApp Chat" },
    servicePage: {
      back: "Back to Home",
      cta: "Consult This Service",
      openPage: "View Service Page",
      related: "Other Services",
      notFound: "Service not found.",
    },
  },
};

export const MARQUEE_ITEMS = [
  "SLCP", "WRAP", "BSCI", "SMETA", "Better Work", "GRS", "GOTS", "RCS", "OCS",
  "ZDHC", "MRSL", "RSL", "BEPI", "Worldly FEM", "ISO 14001", "Leadership", "Soft Skills",
];
